<template>
  <section class="recent-post-section alif-blog-section">
    <div class="container-fluid">
      <div class="row justify-content-center section-spacing">
        <div class="col-lg-6">
          <div class="text-center">
            <h1 class="main-heading-1-gradient">Our recent Post</h1>
            <p class="main-content-1">
              Stay on track and keep the overseas education trends on your
              fingertip with the latest updates from us!
            </p>
          </div>
        </div>
      </div>
      <div class="row section-bottom-spacing blog-spacing">
        <div class="col-lg-12">
          <div>
            <h5 class="blog-main-heading">Recent Blogs</h5>
          </div>
          <BlogSlickSlider
            :recentPostsData="recentPostData['test-blog']['data-1']"
            :slidesShow="4"
          />
        </div>
      </div>
      <div class="row section-spacing blog-spacing">
        <div class="col-lg-8">
          <div>
            <div>
              <h5 class="blog-main-heading">Recent Blogs</h5>
            </div>
            <BlogSlickSlider
              :recentPostsData="recentPostData['test-blog']['data-1']"
              :slidesShow="2"
            />
          </div>
          <div class="mt-5">
            <div>
              <h5 class="blog-main-heading">Recent Blogs</h5>
            </div>
            <BlogSlickSlider
              :recentPostsData="recentPostData['test-blog']['data-1']"
              :slidesShow="2"
            />
          </div>
        </div>
        <div class="col-lg-4">
         <div>
            <h5 class="blog-main-heading">Recent Blogs</h5>
          </div>
         <RecentBlogs />
        </div>
      </div>
      <div class="row section-spacing blog-spacing">
        <div class="col-lg-8">
          <div>
            <div>
              <h5 class="blog-main-heading">Recent Blogs</h5>
            </div>
            <BlogSlickSlider
              :recentPostsData="recentPostData['test-blog']['data-1']"
              :slidesShow="2"
            />
          </div>
          <div class="mt-5">
            <div>
              <h5 class="blog-main-heading">Recent Blogs</h5>
            </div>
            <BlogSlickSlider
              :recentPostsData="recentPostData['test-blog']['data-1']"
              :slidesShow="2"
            />
          </div>
        </div>
        <div class="col-lg-4">
         <div>
            <h5 class="blog-main-heading">
             CATEGORIES
            </h5>
          </div>
         <BlogCategories />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BlogSlickSlider from "@/components/pages/Blogs/BlogSlickSlider.vue";
import RecentBlogs from "@/components/pages/Blogs/RecentBlogs.vue";
import BlogCategories from "@/components/pages/Blogs/BlogCategories.vue";


export default {
  components: {
    BlogSlickSlider,
    RecentBlogs,
    BlogCategories 
  },

  data() {
    return {};
  },
};
</script>

<style>
.blog-main-heading {
  background: rgb(83, 103, 255);
  background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);
  font-weight: 600;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  padding-bottom: 20px;
  text-transform: uppercase;
}
.alif-blog-section .slick-prev {
  right: 1% !important;
}
.alif-blog-section .slick-next {
 left: 1% !important;
}
.blog-spacing {
 gap: 3rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Blogs/MainBlog.vue